import React from 'react'

import { AuthenticatedLayout } from './Authenticated'
import { PublicLayout } from './Public'
import { useMaintenanceMode } from '../hooks/useMaintenanceMode/useMaintenanceMode'
import { MaintenanceMode } from '../views/MaintenanceMode/MaintenanceMode'
import { ExceptionLayout } from './ExceptionLayout'
import { AppShell } from './AppShell'

interface LayoutProps {
  variant: 'authenticated' | 'public' | 'exception'
}

export const Layout: React.FC<LayoutProps> = ({ variant }) => {
  const isMaintenanceMode = useMaintenanceMode()

  if (isMaintenanceMode) {
    return (
      <AppShell>
        <MaintenanceMode />
      </AppShell>
    )
  }

  if (variant === 'exception') {
    return <ExceptionLayout />
  }

  if (variant === 'authenticated') {
    return <AuthenticatedLayout />
  }

  return <PublicLayout />
}
